// DataContext.js
import React, { createContext, useContext } from "react";

export const LeadsData = createContext();

export function useLeadsData() {
    return useContext(LeadsData);
}
